import { Link } from 'react-router-dom';
import Container from '@/components/base/Container';
import { categories } from '@/mocks/topics';
import { navItems, siteInfo } from '@/mocks/site';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-16 bg-primary-950 text-background-100">
      <Container className="py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50 font-heading text-lg font-bold text-primary-900">
                料
              </span>
              <span className="font-heading text-lg font-bold tracking-wide">{siteInfo.name}</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">{siteInfo.intro}</p>
            <p className="mt-4 flex items-center gap-2 text-sm text-background-300">
              <i className="ri-mail-line text-accent-400"></i>
              {siteInfo.email}
            </p>
          </div>

          <div>
            <h3 className="mb-4 text-sm font-semibold tracking-wide text-background-50">站内导航</h3>
            <ul className="flex flex-col gap-2.5 text-sm">
              {navItems.map((item) => (
                <li key={item.path}>
                  <Link to={item.path} className="cursor-pointer text-background-300 transition-colors hover:text-accent-400">
                    {item.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/tracking" className="cursor-pointer text-background-300 transition-colors hover:text-accent-400">
                  追踪榜单
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-sm font-semibold tracking-wide text-background-50">内容分类</h3>
            <ul className="flex flex-col gap-2.5 text-sm">
              {categories
                .filter((category) => category.id !== 'all')
                .map((category) => (
                  <li key={category.id}>
                    <Link
                      to={`/tracking?cat=${category.id}`}
                      className="cursor-pointer text-background-300 transition-colors hover:text-accent-400"
                    >
                      {category.name}
                    </Link>
                  </li>
                ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {siteInfo.name} · 保留所有权利</p>
          <p className="leading-relaxed">
            本站内容基于公开信息整理，仅供信息参考，不构成对任何个人或机构的评价。
          </p>
        </div>
      </Container>
    </footer>
  );
}